import axios from "axios";
console.log(process.env.REACT_APP_URL);

const Api = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

// Request interceptor to add authorization header dynamically
Api.interceptors.request.use(
  function (config) {
    // Get the latest token from localStorage on each request
    const token = localStorage.getItem("authorization");
    if (token) {
      config.headers.Authorization = token;
    }
    config.headers["x-client-app"] = "b4t_react_admin";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor for handling responses
Api.interceptors.response.use(
  function (response) {
    // Handle successful responses (status codes 2xx)
    return response;
  },
  function (error) {
    // Handle authentication errors
    if (error.response?.status === 401) {
      console.error("Authentication failed - redirecting to login");
      localStorage.removeItem("authorization");
      // Optionally redirect to login page
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default Api;
